import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { Mixpanel } from '../../config/Mixpanel'
import Constants from '../../common/constants'
import { ClipLoader } from 'react-spinners'
import { useNavigate } from 'react-router-dom'
import './index.css'

const personaliseBenefits = [
    "Industry-Verified Certification",
    "Lifetime Access to 3100+ More Courses",
    "Live Doubt Solving"
]

const normalBenefits = [
    "Certification starts at ₹129",
    "Lifetime Access to 3100+ More Courses",
    "Limited Doubt Solving"
]

const BottomEvenPersonaliseSection = ({ razorpayHandler, onboardingData, handleSkip }) => {

    const navigate = useNavigate()

    const [ loading, setLoading ] = useState(false)

    const newLearners = useCallback(() => {
        const time = new Date()
        const hours = time.getHours()
        const minutes = time.getMinutes()
        let maxLearners = hours.toString() + (minutes <= 9 ? "0" + minutes.toString() : minutes.toString())
        console.log(maxLearners)
        return Math.max(parseInt(maxLearners)+9, 171)
    }, [])

    
    return (
        <div className='border md:border-2 border-[#1CA571] rounded-2xl p-3 text-center md:mt-10 bottom-linear-gradient-background' >
            <h3 className='text-2xl font-semibold px-4'>How Do You Want To Proceed?</h3>
            <div className='md:hidden'>
                <div className='bg-[#1CA571] mt-2 flex justify-center items-center p-2 rounded-lg' onClick={() => {
                    Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS_BOTTOM_PERSONALISE_PAYMENT)
                    setLoading(true)
                    razorpayHandler(() => setLoading(false))
                }}>
                    {loading ? <div className='flex justify-center items-center'>
                        <ClipLoader color='black' size={20} />
                    </div> :
                    <>
                        <div>
                            <p className='font-semibold'>Unlock Personalised Course</p>
                        </div>
                        <div className='ml-3'>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Arrow.png?updatedAt=1694517910311" width={34} height={34} alt="right arrow" />
                        </div>
                    </>}
                </div>
                <p className='text-xs font-medium mt-0.5 mb-2'>8/10 Candidates Got Hired Who Took This Course</p>
                <p className='font-semibold'>or</p>
                <div className='bg-[#0E2C4B] mt-2 border border-[#1983D0] px-2 py-3.5 rounded-lg' onClick={() => {
                    Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS_BOTTOM_NORMAL)
                    handleSkip()
                }}>
                    <p className='text-[#1983D0] font-semibold'>Continue To Standard Course (Free)</p>
                </div>
                <p className='text-xs font-medium my-0.5'> Verified certificate not included</p>
            </div>
            <div className='md:flex hidden justify-between h-full mt-6'>
                <div className='w-[45%]'>
                    <h3 className='text-xl font-semibold'>Unlock Personalised Course</h3>
                    <p className='font-semibold mt-1 mb-5'>Early Bird Discount: ₹199 <span className='text-[#E06064] line-through'>₹1199</span></p>
                    {personaliseBenefits?.map((item, index) => (
                        <div key={index} className='bg-[#1A3A5A] flex items-center rounded-lg py-2 px-1 mt-2 justify-center'>
                            <FontAwesomeIcon icon={faCircleCheck} color='#4AAD60'/>
                            <p className='text-sm  ml-2 font-semibold'>{item}</p>
                        </div>
                    ))}
                    <div className='bg-[#1CA571] mt-6 flex justify-center cursor-pointer items-center p-2 rounded-lg' onClick={() => {
                        Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS_BOTTOM_PERSONALISE_PAYMENT)
                        setLoading(true)
                        razorpayHandler(() => setLoading(false))
                    }}>
                        {loading ? <div className='flex justify-center items-center'>
                            <ClipLoader color='black' size={20} />
                        </div> :
                        <>
                            <p className='font-semibold'>Unlock Personalised Course</p>
                            <div className='ml-3'>
                                <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Arrow.png?updatedAt=1694517910311" width={34} height={34} alt="right arrow" />
                            </div>
                        </>}
                    </div>
                    <div className='flex items-center justify-center mt-1'>
                        <div className='w-[62px] h-full'>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8604.png?updatedAt=1687502602718" alt="user images" className='w-full h-auto'/>
                        </div>
                        <p className='text-xs font-medium'>{newLearners()} Unlocks Today</p>
                    </div>
                </div>
                <div className='w-[2px] h-[290px] bg-[#60AFFF]'></div>
                <div className='w-[45%]'>
                    <h3 className='text-xl font-semibold'>Unlock Standard Course</h3>
                    <p className='font-semibold mt-1 mb-5'>Free (3x Slower)</p>
                    {normalBenefits?.map((item, index) => (
                        <div key={index} className='bg-[#1A3A5A] flex items-center rounded-lg py-2 px-1 mt-2 justify-center'>
                            <FontAwesomeIcon icon={faCircleCheck} color='#4AAD60'/>
                            <p className='text-sm  ml-2 font-semibold'>{item}</p>
                        </div>
                    ))}
                    <div className='bg-[#0E2C4B] border-2 border-[#1983D0] mt-6 flex justify-center cursor-pointer items-center py-3 rounded-lg' onClick={() => {
                        Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS_BOTTOM_NORMAL)
                        handleSkip()
                    }}>
                        <p className='font-semibold text-[#1983D0]'>Continue To Standard Course (Free)</p>
                    </div>
                    <p className='text-xs font-medium mt-2'>Verified certificate not included</p>
                </div>
            </div>
        </div>
    )
}

export default BottomEvenPersonaliseSection